import {AbstractControl, ValidationErrors} from "@angular/forms";

export function matchesOtherControlValidator(controlName: string) {
  return (control: AbstractControl): ValidationErrors | null => {
    if (!control.value || control.parent?.get(controlName)?.value === control.value) {
      return null;
    }

    control.setErrors({matches: true});
    return {matches: true};
  };
}
